import React from 'react';

const LanguageContext = React.createContext(process.env.REACT_APP_LANGUAGE);

export default LanguageContext;
